import { requestWithToken as request, uploadFile as uf } from "./api";
import { buildQuery } from "@/utils/queryString";

export const getCarteraAnalista = () => request.get(`/analyst_view/get_all/`);

export function getUploadedFiles(company_id, file_id, page) {
    const result = request.get(
        `/analyst_view/${company_id}/all_uploads/${buildQuery({ page, file_id })}`,
    );
    return result;
}

export const allAnalysts = () => request.get(`/analyst_view/analysts_list/`);
export const allCompanies = (all = false, search = "") =>
    request.get(`/analyst_view/companies_list/${buildQuery({ all, search })}`);
export function saveCartera(
    company_id,
    old_analists,
    new_analists,
    deleted_analists,
) {
    const param = {
        old_analists: old_analists,
        new_analists: new_analists,
        deleted_analists: deleted_analists,
    };
    return request.post(`/analyst_view/${company_id}/save_cartera/`, param);
}

export async function uploadFile(id, file) {
    return uf(`/analyst_view/${id}/upload_logo/`, file);
}

export const deleteUploadedFile = (idCompany) =>
    request.get(`/analyst_view/${idCompany}/delete_uploaded_file/`);

export const getLedgerCutoff = (company_id) =>
    request.get(`/ledger_cutoff/${company_id}/cutoff/`);

export const setLedgerCutoff = (company_id, ledger_cutoff_date) =>
    request.post(`/ledger_cutoff/${company_id}/set_cutoff/`, {
        ledger_cutoff_date,
    });

// Sube el Excel del mayor de una empresa y ENCOLA la importación (is_ledger).
// businessType (opcional): nombre del tipo de negocio (uno de los 5:
//   Productor/Comercializador/Consultor/Intermediario/Rental).
// scope (opcional): "full" (o vacío) → carga inicial que reemplaza TODO el mayor;
//   un año ("2025") → subida incremental que reemplaza SOLO ese año y no toca los
//   demás (el archivo debe contener solo filas de ese año).
// 202 {status:'processing'} — el import corre en RQ; sondear el estado con
//   getLedgerLastUpload (last_ledger_import_status: P/S/E).
// 400 (sin archivo / scope inválido); 409 (import ya en curso).
export const uploadLedger = (company_id, file, businessType, scope) => {
    const formData = new FormData();
    formData.append("file", file);
    if (businessType) {
        formData.append("business_type", businessType);
    }
    if (scope) {
        formData.append("ledger_scope", scope);
    }
    return request.post(`/ledger_cutoff/${company_id}/upload/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

// Metadatos de la última subida del mayor + tipo de negocio actual, para
// mostrarlos y pre-cargar el selector en el modal.
export const getLedgerLastUpload = (company_id) =>
    request.get(`/ledger_cutoff/${company_id}/last_upload/`);

// Visto bueno del analista al plan de cuentas: baja el banner "En revisión"
// del cliente (CompanyDetails.needs_account_plan_review = False).
export const approveAccountPlan = (companyId) =>
    request.post(`/analyst_view/${companyId}/approve_account_plan/`, {});

export function saveCompany(rut, name) {
    const param = {
        rut: rut,
        name: name,
    };
    return request.post(`/analyst_view/save_company/`, param);
}

export const getDetalleCompania = (id, full) =>
    request.get(`/analyst_view/${id}/complementary_data/${buildQuery({ full })}`);

export const getFileData = (id) =>
    request.get(`/analyst_view/${id}/file_data/`);

export const getAccountPlanForCompany = (id) =>
    request.get(
        `/classification_admin_view/${id}/get_account_plan_for_company/`,
    );

export const getCategories = () =>
    request.post(`/classification_user_view/categories/`);

export const hasNewDocsByCompany = () =>
    request.get(`/classification_user_view/has_new_documents_by_company/`);

export const get_documents_involved = (
    companies_involved,
    document_type,
    from_day = null,
    to_day = null,
    obligation_name,
    ledger_only = false,
) => {
    const data = {
        companies_involved: companies_involved,
        document_type: document_type,
        from_day,
        to_day,
        obligation_name,
        ledger_only,
    };
    return request.post(`/classification_user_view/documents_involved/`, data);
};

export const resolve_counterpart_by_alias = (alias, document_type) => {
    const data = { alias, document_type };
    return request.post(
        `/classification_user_view/resolve_counterpart_by_alias/`,
        data,
    );
};

export const get_counterpart_monthly_history = (
    ci_id,
    document_type,
    from_day,
    to_day,
    level_2_name = "Ventas",
    level_1_name = null,
    counterpart_type = null,
) => {
    const data = {
        ci_id,
        document_type,
        from_day,
        to_day,
        level_2_name,
        level_1_name,
        counterpart_type,
    };
    return request.post(
        `/classification_user_view/counterpart_monthly_history/`,
        data,
    );
};

// Drawer del Análisis de Ventas: documentos accruados a un RANGO con monto
// prorrateado (matchea el ranking). Endpoint separado de documents_involved
// — este filtra por fecha devengada, no por emitted_at.
//
// El rango lo controla el caller (header del drawer: último año / 6 meses /
// 2 años). Nombre del export se conserva por compatibilidad histórica con
// los consumers — el endpoint sigue siendo `sales_analysis_counterpart_month_docs`.
export const get_counterpart_month_docs = (
    ci_id,
    from_day,
    to_day,
    document_type = "C",
    level_2_name = "Ventas",
    level_1_name = null,
    counterpart_type = null,
) => {
    const data = {
        ci_id,
        init_date: from_day,
        end_date: to_day,
        document_type,
        level_2_name,
        level_1_name,
        counterpart_type,
    };
    return request.post(
        `/classification_user_view/sales_analysis_counterpart_month_docs/`,
        data,
    );
};

export const get_devengo_x_company_doc = (doc_id, account_id) => {
    const data = {
        doc_id: doc_id,
        plan_account_id: account_id,
    };
    return request.post(`/classification_user_view/get_devengo/`, data);
};

// Versión batch: resuelve el rango de devengo de todos los pares (doc × cuenta)
// en una sola request (colapsa el N+1 de ChangeAccrual).
export const get_devengo_batch = (docs_ids, plan_accounts_ids) => {
    return request.post(`/classification_user_view/get_devengo_batch/`, {
        docs_ids,
        plan_accounts_ids,
    });
};

export const delete_devengo_by_doc_id = (doc_id, plan_account_id) => {
    const data = {
        doc_id: doc_id,
        plan_account_id: plan_account_id,
    };
    return request.post(`/classification_user_view/delete_devengo/`, data);
};

export const save_devengo = (data) => {
    return request.post(`/classification_user_view/save_devengo/`, data);
};

export const get_counterpart = (
    ci_id,
    pay_or_charge,
    from_day = null,
    to_day = null,
    obligation_name = "Otros",
) => {
    const data = {
        single: true,
        ci_id: ci_id,
        document_type: pay_or_charge,
        from_day,
        to_day,
        obligation_name,
    };
    return request.post(`/classification_user_view/counterparts/`, data);
};

export const get_paginated_counterparts = (data) => {
    return request.post(`/classification_user_view/counterparts/`, data);
};

// Descarga toda la data del mayor (ERP) de la empresa del usuario como un .xlsx
// re-subible. El backend lo regenera desde los documentos persistidos (mismo
// esquema que el importador). responseType blob → el caller arma la descarga.
export const downloadLedgerFile = () =>
    request.get(`/classification_user_view/download_ledger/`, {
        responseType: "blob",
    });

export const get_account_plan_by_company_ordered = (data) => {
    return request.post(
        `/classification_user_view/get_account_plan_by_company_ordered/`,
        data,
    );
};

export const get_prorates_x_company_involved = (
    company_involved_id,
    document_id_selected,
    document_type,
    obligation_name,
) => {
    const data = {
        company_involved_id: company_involved_id,
        document_id_selected: document_id_selected,
        document_type: document_type,
        obligation_name: obligation_name,
    };

    return request.post(
        `/classification_user_view/get_prorates_x_company_involved/`,
        data,
    );
};

// Detalle completo del devengo de un documento (cada fila: cuenta × mes × %),
// para el visualizador read-only del mayor.
export const get_doc_accruals = (doc_id) =>
    request.post(`/classification_user_view/get_doc_accruals/`, { doc_id });

export const save_analysts_per_company = (company_id, data) =>
    request.post(
        `/analyst_view/${company_id}/save_analysts_per_company/`,
        data,
    );

export const save_companies_analyst = (user_id, data) =>
    request.post(`/analyst_view/${user_id}/save_companies_analyst/`, data);

export const companies_per_user = (user_id) =>
    request.get(`/analyst_view/${user_id}/companies_per_user`);

export const users_of_company = (company_id) =>
    request.get(`/analyst_view/${company_id}/users_of_company`);

// Cola de solicitudes de alta de empresa (Opción B) — analista/staff.
export const linkRequests = () =>
    request.get(`/analyst_view/link_requests/`);

export const approveLinkRequest = (id) =>
    request.post(`/analyst_view/${id}/approve_link_request/`);

export const rejectLinkRequest = (id, reason) =>
    request.post(`/analyst_view/${id}/reject_link_request/`, { reason });

export const save_prorate_tree = (params) =>
    request.post(`/classification_user_view/save_prorate_tree/`, params);

export const delete_prorate_by_company_involved = (data) =>
    request.post(
        `/classification_user_view/delete_prorate_by_company_involved/`,
        data,
    );

export const createAccount = (companyId, level_2_id, cuenta_name, order) => {
    const params = { level_2_id: level_2_id, cuenta_name: cuenta_name, order };
    return request.post(
        `/classification_admin_view/${companyId}/create_account_for_company/`,
        params,
    );
};
export const editAccount = (
    companyId,
    account_id,
    level_2_id,
    cuenta_name,
    order,
) => {
    const params = {
        account_id,
        level_2_id: level_2_id,
        cuenta_name: cuenta_name,
        order,
    };
    return request.post(
        `/classification_admin_view/${companyId}/edit_account_for_company/`,
        params,
    );
};

export const deleteAccount = (companyId, account_id) => {
    const params = {
        account_id,
    };
    return request.post(
        `/classification_admin_view/${companyId}/delete_plan_account_company/`,
        params,
    );
};

export const saveAccountPlans = (id, checked, already_saved) => {
    const params = { raw_account_plans: checked, already_saved: already_saved };
    return request.post(
        `/classification_admin_view/${id}/save_account_plans_for_company/`,
        params,
    );
};

export const makeUniquePlanAccounts = (id_company) => {
    return request.post(
        `/classification_admin_view/${id_company}/make_unique_plan_accounts_by_company/`,
    );
};

export const upload_all_plan_accounts = (id_company, fdFile) => {
    return request.post(
        `/classification_admin_view/${id_company}/upload_plan_accounts_file/`,
        fdFile,
    );
};

export const getFirstRows = (id) =>
    request.get(`/analyst_view/${id}/load_first_rows/`);

export const grabarConfiguracion = (id, params = {}) => {
    return request.post(`/analyst_view/${id}/save_configuration/`, params);
};

export const toggleFile = (id, toggle, company) => {
    const params = { toggle: toggle, company: company };
    return request.post(`/analyst_view/${id}/toggle_file/`, params);
};

export const sendEmailDocs = (company, userid, which) => {
    const params = { userid: userid, which: which };
    return request.post(`/analyst_view/${company}/send_email_docs/`, params);
};

export const updateGeneralBookSheetId = (id_drive_file, company_id) =>
    request.post("/analyst_view/update_general_book_drive_id/", {
        id_drive_file,
        company_id,
    });

export const getUsersByCompany = (company_id) =>
    request.get(`/analyst_view/${company_id}/users_by_company/`, {});

export const updateUserOperations = (company_id, userOps) =>
    request.post(
        `/analyst_view/${company_id}/update_user_operations/`,
        userOps,
    );

export const saveTipoNegocio = (company_id, checked, classify_by_sales) =>
    request.post("/analyst_view/save_business_type/", {
        company_id,
        checked,
        classify_by_sales,
    });

export const getAttributes = (company_id) =>
    request.get(`/attributes/${buildQuery({ company_id })}`);

export const addAttributes = (attribute) =>
    request.post(`/attributes/`, attribute);

export const deleteAttributes = (attribute, company_id) =>
    request.delete(`/attributes/${attribute.id}`, { data: { company_id } });
